import { unplugin } from "./unplugin";

export default unplugin.webpack;
